import { render } from "./Double.vue?vue&type=template&id=7b0bcde5&scoped=true&ts=true"
import script from "./Double.vue?vue&type=script&lang=ts"
export * from "./Double.vue?vue&type=script&lang=ts"

import "./Double.vue?vue&type=style&index=0&id=7b0bcde5&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0bcde5"]])

export default __exports__